export default __webpack_public_path__ + "static/media/logo-portal-mini.3cdc603c.svg";